"use client";

import React from "react";
import styled from "styled-components";
import { blockPaddingBottom, Box } from "@motorata/base-ui.components.atoms._atoms";
import { OfferType } from "@motorata/base-ui.types.api";
import OfferContent from "@/views/offer/OfferContent";
import OfferSideBar from "@/views/offer/OfferSideBar";
import OfferContentReport from "@/views/offer/OfferContentReport";

export default function OfferContentTemplate({ offer, coordinator }: {
  offer: OfferType
  coordinator: string
}) {

  return (
    <Wrapper>
      <OfferContent id={offer.id} status={offer.status} brand={offer.brand} model={offer.model}
                    version={offer.version} type={offer.type} bodyType={offer.bodyType} state={offer.state}
                    year={offer.year}
                    course={offer.course} gearBox={offer.gearBox} enginePower={offer.enginePower}
                    engineCapacity={offer.engineCapacity} description={offer.description} params={offer.params}
                    images={offer.images} youtube={offer.youtube} equipment={offer.equipment} dtModified={offer.dtModified}
                    coordinator={coordinator} />
      <OfferSideBar
        id={offer.id} type={offer.type} brand={offer.brand} model={offer.model}
        finance={offer.finance}
        profile={offer.profile}
        client={offer.client}
        year={offer.year}
      />
      <OfferContentReport dtModified={offer.dtModified} mobile={true} />
    </Wrapper>
  );
}


const Wrapper = styled(Box)`
  ${blockPaddingBottom};
  display: flex;
  justify-content: space-between;
  
  > div:nth-child(1) {
    width: calc(65% - ${({ theme }) => theme.space.S});
  }

  > div:nth-child(2) {
    width: calc(35% - ${({ theme }) => theme.space.S});
  }
  
  @media (min-width: 800px){
    margin-top: -${({ theme }) => theme.space.M};
  }
  
  @media (max-width: 1200px) {
    > div:nth-child(1) {
      width: calc(60% - ${({ theme }) => theme.space.S});
    }

    > div:nth-child(2) {
      width: calc(40% - ${({ theme }) => theme.space.S});
    }
  }

  @media (max-width: 1000px) {
    flex-direction: column;

    > div {
      width: 100% !important;
    }
  };
  `;
